import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class ProviderService extends Service {
  path = 'prestador'

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async getTypes(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/tiposPrestador`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }

  async delete(params: any) {
    const httpResponse = await this.httpClient.delete(
      this.path + `?PrestadorId=${params}`
    )
    return httpResponse
  }

  async put(id: string | number, params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?PrestadorId=${id}`,
      params
    )
    return httpResponse
  }

  async ativar(id?: string | number) {
    const httpResponse = await this.httpClient.put(
      this.path + `/ativar?PrestadorId=${id}`
    )
    return httpResponse
  }
}

export const providerService = new ProviderService()
